<div [formGroup]="formGroup" class="gw-flex gw-flex-col gw-gap-x-large">
  <div>
    <gatewee-select-v3
      id="clientTypeSelect"
      [label]="
        'features.onboarding.steps.businessProfileForm.inputs.clientType'
          | translate
      "
      [items]="clientTypes"
      formControlName="clientType"
      [placeholder]="
        'features.onboarding.businessProfileForm.placeholders.clientType'
          | translate
      "
    ></gatewee-select-v3>
  </div>

  <div>
    <label class="gw-form-label gw-block gw-mb-x-small">{{
      'features.onboarding.steps.businessProfileForm.inputs.region' | translate
    }}</label>
    <div class="gw-flex gw-flex-col gw-gap-x-small">
      <div
        class="gw-flex gw-items-center gw-gap-x-small"
        *ngFor="let region of operatingRegions"
      >
        <input
          class="gw-checkbox-base"
          type="checkbox"
          [value]="region"
          (change)="onCheckboxChange($event, 'operatingRegions')"
          [checked]="isChecked('operatingRegions', region)"
          id="region-{{ region }}"
        />
        <label class="gw-checkbox-label" [for]="'region-' + region">
          {{
            'enums.businessGenerics.operatingRegion.' + (region | camelcase)
              | translate
          }}
        </label>
      </div>
    </div>
  </div>

  <div>
    <label class="gw-form-label gw-block gw-mb-x-small">{{
      'features.onboarding.steps.businessProfileForm.inputs.organizationalTools'
        | translate
    }}</label>
    <div class="gw-flex gw-flex-col gw-gap-x-small">
      <div
        class="gw-flex gw-items-center gw-gap-x-small"
        *ngFor="let tool of organizationalTools"
      >
        <input
          class="gw-checkbox-base"
          type="checkbox"
          [value]="tool"
          (change)="onCheckboxChange($event, 'organizationalTools')"
          [checked]="isChecked('organizationalTools', tool)"
          id="tool-{{ tool }}"
        />
        <label class="gw-checkbox-label" [for]="'tool-' + tool">
          {{
            'enums.businessGenerics.organizationalTool.' + (tool | camelcase)
              | translate
          }}
        </label>
      </div>
    </div>
  </div>
</div>
